import newsFileList from './modules/newsFileList'

export default {
  newsFileList
}
